import { render, staticRenderFns } from "./RegisterIndex.vue?vue&type=template&id=1b0d99c0&scoped=true&"
import script from "./RegisterIndex.vue?vue&type=script&lang=js&"
export * from "./RegisterIndex.vue?vue&type=script&lang=js&"
import style0 from "./RegisterIndex.vue?vue&type=style&index=0&id=1b0d99c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0d99c0",
  null
  
)

export default component.exports